
const swiperContainerP = document.getElementsByClassName('carousel_product');

for (var i = 0; i < swiperContainerP.length; i++) {
  swiperContainerP[i].classList.add('swiperP' + i);
  const swiperPage = swiperContainerP[i].querySelector('.swiper-pagination');

  if (swiperPage) {
    swiperPage.classList.add('pageP' + i);
  }

  // Find the corresponding thumbnail swiper
  const thumbsContainer = swiperContainerP[i].nextElementSibling;
  if (thumbsContainer && thumbsContainer.classList.contains('carousel_thumbs')) {
    thumbsContainer.classList.add('swiperThumbs' + i);

    // Initialize thumbnail swiper
    const thumbsSwiper = new Swiper('.swiperThumbs' + i, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 0,
      watchSlidesProgress: true,
    });

    // Initialize main swiper and link thumbs
    var mySwiperP = new Swiper('.swiperP' + i, {
      direction: 'horizontal',
      loop: false,
      speed: 420,
      slidesPerView: 1.08,
      spaceBetween: 5,
      effect: 'slide',
      thumbs: {
        swiper: thumbsSwiper,
      },
      breakpoints: {
      996: {
        slidesPerView: 1,
        effect: 'fade',
      },
    },
    });
  }
}


/* Open Cart */

// const detailLinks = qsa('details a')

// detailLinks.forEach((link) => {
// 	link.addEventListener('click', (e) => {
// 		e.stopPropagation()
// 	})
// })

// /* Details Animator */
// const details = document.querySelectorAll('details')

// if (details) {
// 	details.forEach((targetDetail) => {
// 		targetDetail.addEventListener('click', function (e) {
// 			if (targetDetail.hasAttribute('open')) {
// 				e.preventDefault()
// 				targetDetail.classList.add('closing')
// 				setTimeout(() => {
// 					targetDetail.removeAttribute('open')
// 					targetDetail.classList.remove('closing')
// 				}, 390)
// 			}
// 		})
// 	})
// }


/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({})

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	if (state.requestType == 'add') {
		const form = state.info.initiator
		let btnInner = ''

		const btn = form.querySelector('button[type="submit"]')
		if (btn) {
			btnInner = btn.innerHTML
			btn.innerHTML = 'ADDING'
		}

		subscribeToResult((state) => {
			const btn = form.querySelector('button[type="submit"]')
			if (state.responseData.ok) {
				cartOpen()
			}

			if (btn) {
				setTimeout(() => {
					btn.innerHTML = btnInner
				}, 300)
			}
		})
	}
})


/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('video.lazy');
console.log('llVideos:', llVideos);
if (llVideos.length > 0) {
	enterView({
		selector: '.video-ll',
		enter: function (el) {
			el.load()
			el.play()
		},
		offset: 0.1,
	})
}


// const subMenuItems = document.querySelectorAll('.desktop__sub-menu .menu a')
// const subMenuInitImage = document.querySelector('.desktop__sub-menu .image-holder img ')
// if(subMenuItems && subMenuInitImage) {
// 	subMenuItems.forEach(item => {
//   const hoverImgUrl = item.dataset.collectionImg;
//   if (hoverImgUrl && hoverImgUrl.length > 1) {
//     item.addEventListener('mouseenter', () => {
//       console.log('Image:', hoverImgUrl);
//        subMenuInitImage.src = hoverImgUrl;
//     });
//   }
// });
// }

document.addEventListener("DOMContentLoaded", () => {
	// main DOM content loaded

	const header = document.querySelector('#shopify-section-header');
	// intially disabled pointer events on the home link , so it doesnt trigger
	// as soon redirected to a new page
	if (header) {
		const logo = header.querySelector('.header__logo');
		if (logo) {
			setTimeout(() => {
				logo.style.pointerEvents = 'all';
			}, 500)
		}
	}


	const btnSubMenu = document.querySelector('.open-sub-menu')
	const btnSearch = document.querySelector('.open-search')
	const searchBar = document.querySelector('.search-bar-overlay')
	const subMenu = document.querySelector('.desktop__sub-menu')
	const darkOverlay = document.querySelector('.dark-overlay')

	if (btnSubMenu && subMenu) {
		btnSubMenu.addEventListener('mouseenter', function (event) {
			subMenu.classList.add('active')
			darkOverlay.classList.add('active')
		})
	}

	darkOverlay.addEventListener('mouseenter', function (event) {
		subMenu.classList.remove('active')
		searchBar.classList.remove('active')
		darkOverlay.classList.remove('active')
	})

	
	btnSearch.addEventListener('click', function (event) {
		searchBar.classList.toggle('active')
		darkOverlay.classList.toggle('active')
	})

	document.querySelectorAll('.header__menu-desktop a').forEach(link => {
	link.addEventListener('mouseenter', event => {
		subMenu.classList.remove('active')
		searchBar.classList.remove('active')
		darkOverlay.classList.remove('active')
	});
});


const accordionItems = document.querySelectorAll('.accordion-item');

accordionItems.forEach(item => {
  const header = item.querySelector('.accordion-header');

  header.addEventListener('click', () => {
    // Close all other items
    accordionItems.forEach(i => {
      if (i !== item) {
        i.classList.remove('active');
        i.querySelector('.accordion-content').style.maxHeight = null;
      }
    });

    // Toggle this item
    const content = item.querySelector('.accordion-content');
    if (item.classList.contains('active')) {
      item.classList.remove('active');
      content.style.maxHeight = null;
    } else {
      item.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
});

  
  const links = document.querySelectorAll('.desktop__sub-menu a[data-target-cover-img]');
  links.forEach(link => {
    link.addEventListener('mouseenter', () => {


      const targetHandle = link.dataset.targetCoverImg;
      const allCovers = document.querySelectorAll('.collection-cover-image');
      const targetCover = document.querySelector(`.cover-for-${targetHandle}`);
	  const defaultCover = document.querySelector('.cover-for__inital-image');
	

      if (targetCover) {
		allCovers.forEach(img => img.classList.add('inactive'));
		allCovers.forEach(img => img.classList.remove('active'));
        
		targetCover.classList.add('active')
      } else {
		allCovers.forEach(img => img.classList.add('inactive'));
		allCovers.forEach(img => img.classList.remove('active'));

		defaultCover.classList.add('active')
	  }

    });

 	});


		function addLinkToInstaFeed() {
			
			const instafeed = document.querySelector('#insta-feed');
			if (!instafeed) return; 

			const heading = instafeed.querySelector('h2');
			if (!heading) return; 

			const appLink = document.querySelector('.instafeed-bottom-link-wrapper a')
			let linkFromApp = '';
			if(appLink) {
				 linkFromApp = appLink.href
			} 
			const link = document.createElement('a');
			link.href = linkFromApp; 
			link.textContent = '@yuichi.artisans';
			link.className = 'profile-link h2'; 
			
			heading.insertAdjacentElement('afterend', link);
		}
		

		setTimeout(addLinkToInstaFeed, 700)


		function openCollectionFilters(){
			const filter = document.querySelector('.collection__filter');
			if (filter) {
				filter.classList.add('active')
			}
		}

		function closeCollectionFilters(){
			const filter = document.querySelector('.collection__filter');
			if (filter) {
				filter.classList.remove('active')
			}
		}

	const filterBtn = document.querySelector('.product_collection .open-filters');

    if (filterBtn) {
      filterBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openCollectionFilters();
      });
    }

	const closeBtns = document.querySelectorAll('.close-product-filter');

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (typeof closeCollectionFilters === 'function') {
          closeCollectionFilters();
        }
      });
    });


  const applyFilter = document.querySelector('.apply_filter_btn');
  if (applyFilter) {
      applyFilter.addEventListener('click', (e) => {
      e.preventDefault()
      closeCollectionFilters();
      const url = applyFilter.dataset.targetUrl
      if (url) {
        window.location.href = url;
      }
    });
  }

   
  document.querySelector("#mobile-nav-toggle").addEventListener("click", function () {
    this.classList.toggle("active");
    const menu = document.querySelector('.mobile__dropdown-menu')
    if ( menu.classList.contains('active')) {
      menu.classList.remove('active')
    } else {
      menu.classList.add('active')
    }
    
  });



	// end content loaded
})

// Section - Collection List

const collectionTitles = document.querySelectorAll('.collection-title');
const mediaItems = document.querySelectorAll('.img-wrap');

collectionTitles.forEach(title => {
  title.addEventListener('mouseenter', () => {
    const targetHandle = title.dataset.collectionTarget;

    // Remove 'active' from all media items
    mediaItems.forEach(item => item.classList.remove('active'));

    const matchingItem = document.querySelector(`.img-wrap[data-collection-handle="${targetHandle}"]`);
    if (matchingItem) {
      matchingItem.classList.add('active');
    }
  });
});


// Select all Swiper containers with the class
const swiperContainers = document.querySelectorAll('.carousel-version-one');

swiperContainers.forEach((container, index) => {
  // Add unique class per instance
  const uniqueClass = 'swiper-instance-' + index;
  container.classList.add(uniqueClass);

  // Initialize Swiper
  new Swiper('.' + uniqueClass, {
	effect: "coverflow",
    loop: false,
    slidesPerView: 1.7,
    spaceBetween: 70,
    speed: 700,
    centeredSlides: true,
    initialSlide: 0,
    slideToClickedSlide: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: false,
      scale: 0.87 // smaller side slides
    },
  });
});






// localization form
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.style.maxHeight = '0px';
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

   openSelector() {
    this.elements.button.focus();
    const expanded = this.elements.button.getAttribute('aria-expanded') === 'true';
    this.elements.button.setAttribute('aria-expanded', (!expanded).toString());

    if (!expanded) {
      // Open: set maxHeight to scrollHeight
      this.elements.panel.style.maxHeight = this.elements.panel.scrollHeight + 'px';
    } else {
      // Close: set maxHeight to 0
      this.elements.panel.style.maxHeight = '0';
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);
// end localization



// Filters on collection page
document.querySelectorAll('.filters-menu__link').forEach(link => {
  link.addEventListener('click', (event) => {

     document.querySelectorAll('.filters-menu__link').forEach(item => {
      item.classList.remove('selected');
    });

    link.classList.add ('selected')

    const targetUrl = link.getAttribute('data-href');
    const applyButton = document.querySelector('.apply_filter_btn');

    if (applyButton && targetUrl) {
      applyButton.setAttribute('data-target-url', targetUrl);
      applyButton.removeAttribute('aria-disabled');
    }
  });
});
